<script>
import { mapActions, mapState } from 'vuex';
import AffiliatesManage from '../../components/Affiliates/AffiliatesManage';
import AffiliatesLogo from '../../components/Affiliates/AffiliatesLogo';
import AffiliatesSuppliers from '../../components/Affiliates/AffiliatesSuppliers';
import AffiliatesDomains from '../../components/Affiliates/AffiliatesDomains';
import TwOverlay from '../../components/TwOverlay';
import utility from '../../mixins/utility';

export default {
  name: 'Affiliates',
  components: {
    AffiliatesManage,
    AffiliatesLogo,
    AffiliatesSuppliers,
    AffiliatesDomains,
    TwOverlay,
  },
  mixins: [
    utility,
  ],
  data() {
    return {
      createAffiliateShow: false,
      newName: undefined,
    };
  },
  computed: {
    ...mapState({
      affiliates: state => state.affiliates.affiliates,
      affiliate: state => state.affiliates.affiliate,
    }),
    validInput() {
      return !!this.newName;
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      getAffiliates: 'affiliates/getAffiliates',
      getAffiliate: 'affiliates/getAffiliate',
      createAffiliate: 'affiliates/createAffiliate',
      resetState: 'affiliates/resetState',
    }),
    createNewAffiliate() {
      this.createAffiliateShow = false;
      this.createAffiliate({
        name: this.newName,
        token: this.generateRandomString(32),
      });
    },
  },
  mounted() {
    if (!this.affiliates.items.length) {
      this.getAffiliates();
    }
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: 'Affiliates', to: '', disabled: true },
      ],
      title: 'Affiliates',
    });
  },
  beforeRouteLeave(to, from, next) {
    this.resetState();
    next();
  },
};
</script>

<template>
  <v-flex xs12 affiliates__wrapper>
    <tw-overlay :visible="affiliate.loading"/>
    <v-progress-circular
      v-if="affiliate.loading"
      class="affiliates__wrapper-loading"
      indeterminate
    />
    <v-card-text>
      <v-layout>
        <v-flex xs9>
          <v-autocomplete
            :items="affiliates.items"
            :loading="affiliates.loading"
            item-text="name"
            item-value="id"
            placeholder="Select Affiliate"
            @change="getAffiliate"
          />
        </v-flex>
        <v-spacer/>
        <v-flex xs2>
          <v-btn class="mt-3" color="info" @click="createAffiliateShow = true">
            Create Affiliate
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <affiliates-manage/>
        <affiliates-domains/>
        <affiliates-logo/>
        <affiliates-suppliers/>
      </v-layout>
      <v-dialog
        v-model="createAffiliateShow"
        max-width="400px"
        no-click-animation
        persistent
      >
        <v-card>
          <v-card-title>
            <h1>Create new affiliate</h1>
            <v-spacer/>
            <v-btn small icon @click="createAffiliateShow = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-layout wrap mt-4>
              <v-flex xs2 pt-4>
                <v-label>Name</v-label>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  v-model="newName"
                  placeholder="Name"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="!validInput" color="info" @click="createNewAffiliate">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-flex>
</template>

<style lang="scss">
.affiliates__wrapper {
  position: relative;

  &-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/affiliates/affiliates.vue